import { DefaultState } from 'store/types';

export const RESEND_EMAIL_BY_NOTIFICATION_ID_REQUEST = 'RESEND_EMAIL_BY_NOTIFICATION_ID_REQUEST';
export const RESEND_EMAIL_BY_NOTIFICATION_ID_SUCCESS = 'RESEND_EMAIL_BY_NOTIFICATION_ID_SUCCESS';
export const RESEND_EMAIL_BY_NOTIFICATION_ID_FAILURE = 'RESEND_EMAIL_BY_NOTIFICATION_ID_FAILURE';


export type ResendEmailByNotificationIdState = DefaultState & {
};

interface ResendEmailByNotificationIdRequest {
  type: typeof RESEND_EMAIL_BY_NOTIFICATION_ID_REQUEST;
};

interface ResendEmailByNotificationIdSuccess {
  type: typeof RESEND_EMAIL_BY_NOTIFICATION_ID_SUCCESS;
}

interface ResendEmailByNotificationIdFailure {
  type: typeof RESEND_EMAIL_BY_NOTIFICATION_ID_FAILURE;
}

export type ResendEmailByNotificationIdActionTypes = ResendEmailByNotificationIdRequest | ResendEmailByNotificationIdSuccess | ResendEmailByNotificationIdFailure;
